"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CustomerContactFilter model module.
 * @module model/CustomerContactFilter
 * @version 1.1.3-alpha.1
 */
class CustomerContactFilter {
  /**
   * Constructs a new <code>CustomerContactFilter</code>.
   * @alias module:model/CustomerContactFilter
   */
  constructor() {
    CustomerContactFilter.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>CustomerContactFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CustomerContactFilter} obj Optional instance to populate.
   * @return {module:model/CustomerContactFilter} The populated <code>CustomerContactFilter</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CustomerContactFilter();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
      }
      if (data.hasOwnProperty('customer_id')) {
        obj['customer_id'] = _ApiClient.default.convertToType(data['customer_id'], 'String');
      }
      if (data.hasOwnProperty('user_id')) {
        obj['user_id'] = _ApiClient.default.convertToType(data['user_id'], 'String');
      }
      if (data.hasOwnProperty('withAggregates')) {
        obj['withAggregates'] = _ApiClient.default.convertToType(data['withAggregates'], 'Boolean');
      }
      if (data.hasOwnProperty('windowFrom')) {
        obj['windowFrom'] = _ApiClient.default.convertToType(data['windowFrom'], 'String');
      }
      if (data.hasOwnProperty('windowTo')) {
        obj['windowTo'] = _ApiClient.default.convertToType(data['windowTo'], 'String');
      }
      if (data.hasOwnProperty('q')) {
        obj['q'] = _ApiClient.default.convertToType(data['q'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CustomerContactFilter</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomerContactFilter</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['customer_id'] && !(typeof data['customer_id'] === 'string' || data['customer_id'] instanceof String)) {
      throw new Error("Expected the field `customer_id` to be a primitive type in the JSON string but got " + data['customer_id']);
    }
    // ensure the json data is a string
    if (data['user_id'] && !(typeof data['user_id'] === 'string' || data['user_id'] instanceof String)) {
      throw new Error("Expected the field `user_id` to be a primitive type in the JSON string but got " + data['user_id']);
    }
    // ensure the json data is a string
    if (data['q'] && !(typeof data['q'] === 'string' || data['q'] instanceof String)) {
      throw new Error("Expected the field `q` to be a primitive type in the JSON string but got " + data['q']);
    }
    return true;
  }
}

/**
 * @member {Number} id
 */
CustomerContactFilter.prototype['id'] = undefined;

/**
 * @member {String} customer_id
 */
CustomerContactFilter.prototype['customer_id'] = undefined;

/**
 * @member {String} user_id
 */
CustomerContactFilter.prototype['user_id'] = undefined;

/**
 * @member {Boolean} withAggregates
 */
CustomerContactFilter.prototype['withAggregates'] = undefined;

/**
 * @member {String} windowFrom
 */
CustomerContactFilter.prototype['windowFrom'] = undefined;

/**
 * @member {String} windowTo
 */
CustomerContactFilter.prototype['windowTo'] = undefined;

/**
 * @member {String} q
 */
CustomerContactFilter.prototype['q'] = undefined;
var _default = exports.default = CustomerContactFilter;